import { Flex, Typography } from '@banhala/ui-kit';

export const MainName = ({ text, testID }: { text: string; testID?: string }) => {
  return (
    <Flex testID={testID}>
      <Typography type="subtitle1" ellipsizeMode="tail" color='content_primary'>
        {text}
      </Typography>
    </Flex>
  );
};
